import React, { Fragment } from 'react';
import { useQueryClient, useQuery, useMutation } from 'react-query';

import defaultApp from 'constants';

function Language() {
    const queryClient = useQueryClient();

    const restaurant = queryClient.getQueryData('restaurant') || { language: 'en' };
    const language = useQuery('language')?.data || 'en';
    const app = useQuery('app')?.data || defaultApp;

    const languageMutation = useMutation('language-mutation');

    const setLanguage = (lang) => {
        languageMutation.mutate(lang);

        queryClient.setQueryData('app', (prevData) => ({
            ...prevData,
            toggleLanguage: !prevData.toggleLanguage,
        }));
    };

    return (
        <Fragment>
            {restaurant.language !== 'en' && (
                <div className={`language-selector ${app.toggleLanguage ? 'active' : ''}`}>
                    <div className="content">
                        <button
                            type="button"
                            onClick={() => setLanguage('en')}
                            className={language === 'en' ? 'active' : ''}
                            data-test="language-english"
                        >
                            EN
                        </button>
                        <button
                            type="button"
                            className={restaurant.language === language ? 'active' : ''}
                            onClick={() => setLanguage(restaurant.language)}
                            data-test="language-restaurant"
                        >
                            {restaurant.language}
                        </button>
                    </div>
                </div>
            )}
        </Fragment>
    );
}

export default Language;
